<div class="container">
  <div class="row" *ngIf="ultimasEntregas.length > 0">
    <div class="col-md-12 col-sm-12 scroll-table" [ngClass]="{'table-modal': isModal}">
      <table class="table table-sm m-2">
        <thead>
          <tr class="font-weight-bold">
            <th scope="col"> </th>
            <th scope="col">Roteiro</th>
            <th scope="col">Pedido</th>
            <th scope="col">Nome do Motorista</th>
            <th scope="col">Placa Veículo</th>
            <th scope="col">Data Entrega</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let entrega of ultimasEntregas" class="hover-pedido">
            <td class="w-drop small-cell">
              <div class="dropdown hover-btn dropdown">
                <i class="fa fa-ellipsis-v" style="padding: 5px;" data-bs-toggle="dropdown"></i>
                <div class="dropdown-menu shadow" style="border-radius: 8px;">
                  <button data-bs-toggle="modal" data-bs-target="#modalPrincipal" class="dropdown-item mb-1" (click)="abriRoteiro(entrega.NumeroRoteiro, entrega.CodigoCliente)">
                    <img class="icone_roteiro" src="assets/img/icons/abrir_roteiro.svg" class="me-3">Abrir roteiro
                  </button>
                  <button *ngIf="entrega.IdPedidoConfirmacaoEntrega; else block" class="dropdown-item" (click)="getComprovante(entrega)">
                    <img class="icone_roteiro" src="assets/img/icons/download_comprovante.svg" class="me-3">Download comprovante
                  </button>
                  <ng-template #block>
                    <button class="dropdown-item" style="opacity: 0.5;">
                      <img class="icone_roteiro" src="assets/img/icons/download_comprovante.svg" class="me-3">Download comprovante
                    </button>
                  </ng-template>
                </div>
              </div>
            </td>
            <td>{{ entrega.NumeroRoteiro }} </td>
            <td>{{ entrega.NumeroPedido }}</td>
            <td>{{ entrega.NomeMotorista }}</td>
            <td>{{ entrega.PlacaVeiculo }}</td>
            <td>{{ entrega.DataEntrega | date : 'dd/MM/yyyy HH:mm' : '+00:00' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

  <div *ngIf="ultimasEntregas.length == 0" class="nao-relatada">
      <p>Nenhum entrega encontrado.</p>
  </div>
</div>
